var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

var style = { textAlign: 'center', padding: '40px', fontSize: '15px' };

var FadeOut = function (_Component) {
  _inherits(FadeOut, _Component);

  function FadeOut() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FadeOut);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FadeOut.__proto__ || Object.getPrototypeOf(FadeOut)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: true
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FadeOut, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.failedToLoadData();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeOut);
    }
  }, {
    key: 'getErrorMessage',
    value: function getErrorMessage() {
      var key = this.props.messageType;
      switch (key) {
        case 'default':
          return 'module.components.fadeout.error.default';
        default:
          break;
      }
      return 'module.components.fadeout.error.default';
    }
  }, {
    key: 'failedToLoadData',
    value: function failedToLoadData() {
      var _this2 = this;

      this.timeOut = setTimeout(function () {
        _this2.setState({ loading: false });
      }, this.props.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var loading = this.state.loading;

      return React.createElement(
        React.Fragment,
        null,
        loading ? children : React.createElement(
          'div',
          { style: style },
          React.createElement(FormattedMessage, {
            id: this.getErrorMessage()
          })
        )
      );
    }
  }]);

  return FadeOut;
}(Component);

FadeOut.propTypes = {
  children: PropTypes.node.isRequired,
  timeout: PropTypes.number,
  messageType: PropTypes.string
};
FadeOut.defaultProps = {
  timeout: 5000,
  messageType: 'default'
};
export default FadeOut;